/** American odds → decimal multiplier (e.g. +100 → 2.0). */
export function americanToDecimal(odds) {
  const o = Number(odds);
  if (!Number.isFinite(o) || o === 0) return 1;
  if (o > 0) return 1 + o / 100;
  return 1 + 100 / Math.abs(o);
}

/** Parse stored/API odds into a finite American number. */
export function parseAmericanOdds(raw) {
  if (raw == null || raw === "" || raw === "-") return null;
  const n = Number(String(raw).trim());
  return Number.isFinite(n) && n !== 0 ? n : null;
}

/** Decimal multiplier → American odds (rounded). */
export function decimalToAmerican(decimal) {
  const d = Number(decimal);
  if (!Number.isFinite(d) || d <= 1) return 0;
  if (d >= 2) return Math.round((d - 1) * 100);
  return Math.round(-100 / (d - 1));
}

/** Combined parlay decimal odds from leg American prices. */
export function calcParlayCombinedDecimal(legPrices = []) {
  if (!Array.isArray(legPrices) || legPrices.length === 0) return 1;
  return legPrices.reduce(
    (acc, price) => acc * americanToDecimal(price),
    1
  );
}

/** Combined parlay American odds for display. */
export function calcParlayCombinedAmericanOdds(legPrices = []) {
  return decimalToAmerican(calcParlayCombinedDecimal(legPrices));
}

/** Parlay win + payout from risk and leg prices. */
export function calcParlayPayout(risk, legPrices = []) {
  const bet = Number(risk);
  if (!Number.isFinite(bet) || bet <= 0) {
    return { win: 0, payout: 0, multiplier: 1 };
  }
  const multiplier = calcParlayCombinedDecimal(legPrices);
  const payout = bet * multiplier;
  const win = payout - bet;
  return { win, payout, multiplier };
}

export function formatAmericanOdds(odds) {
  const n = Number(odds);
  if (!Number.isFinite(n) || n === 0) return "—";
  return n > 0 ? `+${n}` : `${n}`;
}

/** Minimum legs required to place a parlay. */
export const PARLAY_MIN_LEGS = 2;

export function getLegPricesFromSelections(selections = []) {
  if (!Array.isArray(selections)) return [];
  return selections
    .map((item) => parseAmericanOdds(item?.price))
    .filter((p) => p != null);
}
